import { render, staticRenderFns } from "./GuideLanding.vue?vue&type=template&id=4bb05d57&scoped=true"
import script from "./GuideLanding.vue?vue&type=script&lang=ts&setup=true"
export * from "./GuideLanding.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./GuideLanding.vue?vue&type=style&index=0&id=4bb05d57&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb05d57",
  null
  
)

export default component.exports